import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { StyledContainerWithNav } from '../../styles';

export const StyledAnimationContainer = styled.div`
  width: 255px;
  height: 255px;
  margin-top: 74px;
`;

export const LoadingViewContainer = styled(StyledContainerWithNav)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

export const OnboardingLoadingViewContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 160px;
`;

export const StyledLoadingText = styled.span`
  ${setFontVariant('h5', colorsPalettes.carbon[400])};
  font-weight: 700;
  margin: 24px 0;
  text-align: center;
  max-width: 308px;
`;

export const StyledLoadingSubText = styled.span`
  ${setFontVariant('subsectionTitle', colorsPalettes.carbon[300])};
  font-weight: 400;
  padding: 0 5px;
  text-align: center;
`;
